<router-outlet class="w-full h-full" />
